import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';
import { PayloadAction } from '@reduxjs/toolkit';

import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import Button from '@ui-elements/Button';
import { FetchUserListCsvResponse } from '@mytypes/api';
import { useAppDispatch, useAppSelector } from '~/App/hooks';

import InfoListTable from '~/components/pages/Admin/Users/organisms/InfoListTable';
import { FONT_SIZES } from '~/assets/styles/base';
import { fetchUsers, fetchUserListCsv } from '~/apiTs';
import { GMOASK_STATUS } from '~/constants/api';
import { ADMIN_ROLES } from '~/common/constants';
import { LOCAL_STORAGES } from '~/constants';

const UsersWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`;

const Title = styled(Typography)`
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

const AdminUsers: React.FC<Record<string, never>> = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const users = useAppSelector((state) => state.users);
  const [isDownloadable, setIsDownloadable] = useState(false);

  useEffect(() => {
    console.log('fetchUsers dispatched');
    dispatch(fetchUsers());

    // determine if csv dl btn should be visible according to admin roles set on login
    setIsDownloadable(
      !!localStorage
        .getItem(LOCAL_STORAGES.ADMIN_ROLES)
        ?.split(',')
        .includes(ADMIN_ROLES.USERS_LIST_CSV.toString())
    );
  }, []);

  const exportCsv = async () => {
    const { payload: res } = (await dispatch(fetchUserListCsv())) as PayloadAction<
      FetchUserListCsvResponse,
      string,
      { arg: undefined; requestId: string; requestStatus: 'fulfilled' },
      never
    >;
    if (res.status === GMOASK_STATUS.OK) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      // CSVファイルを出力するために Blob 型のインスタンスを作る
      const blob = new Blob([bom, res.result.csvData], {
        type: 'text/csv;',
      });
      saveAs(blob, `${res.result.fileName}`);
    }
  };

  return (
    <UsersWrapper>
      <TitleWrapper>
        <Title>{t('adminUsers.title')}</Title>
        {isDownloadable && (
          <Button
            size="medium"
            color="primary"
            variant="contained"
            handleClick={exportCsv}
            dataTestId="exportUsers"
          >
            CSV DL
          </Button>
        )}
      </TitleWrapper>
      <InfoListTable users={users} />
    </UsersWrapper>
  );
};

export default AdminUsers;
